export const appUpdateMessages = {
  'zh-CN': {
    eyebrow: '枫记 · 版本更新',
    title: '新版本已就绪', hint: '刷新即可体验最新版本，也可以继续使用，稍后再更新。',
    preview: '外观预览 · 不会刷新页面', previewFeedback: '仅预览外观，未执行任何更新', previewClose: '预览期间卡片保持显示',
    recordingHint: '更新会结束并保存当前记录，然后刷新页面。',
    update: '刷新更新', endAndUpdate: '结束记录并更新', later: '稍后提醒', close: '30 分钟后再提醒',
    available: '有更新', saving: '正在保存', activating: '正在更新',
    blocked: '请等待当前操作完成后再更新。',
    saveError: '保存未完成，页面未刷新。请重试以保存数据并更新。',
    activationError: '更新未完成，页面未刷新。请检查网络后重试。', retry: '重试更新',
  },
  en: {
    eyebrow: 'Maple Log · Update',
    title: 'An update is ready', hint: 'Refresh to enjoy the latest version, or keep going and update when you’re ready.',
    preview: 'Design preview · No page refresh', previewFeedback: 'Preview only. No update was performed.', previewClose: 'The card stays visible during preview',
    recordingHint: 'Updating will finish and save this record, then refresh the page.',
    update: 'Refresh to update', endAndUpdate: 'Finish record and update', later: 'Later', close: 'Remind me in 30 minutes',
    available: 'Update available', saving: 'Saving', activating: 'Updating',
    blocked: 'Wait for the current operation to finish before updating.',
    saveError: 'Saving did not finish. The page has not refreshed. Retry to save your data and update.',
    activationError: 'The update did not finish. The page has not refreshed. Check your connection and retry.', retry: 'Retry update',
  },
}
